export default function Intro({ goTo }) {
  return (
    <div className="scene center">
      <p className="tagline">hi, grey.</p>
      <h1>shooters shoot.</h1>
      <p className="italic" style={{ fontSize: "1.2rem", lineHeight: 1.6 }}>
        i could've just sent a normal "hey let's play" — but if I'm a real
        shooter I have to match my effort with your worth
      </p>
      <p
        style={{
          color: "var(--ink)",
          marginTop: 8,
          fontSize: "1rem",
          lineHeight: 1.7,
          maxWidth: 480,
          marginInline: "auto",
        }}
      >
        so instead i made you a thing. a few silly questions, a tiny game, and a
        small ask at the end. hope you like it!
      </p>
      <div style={{ marginTop: 28 }}>
        <button className="btn" onClick={() => goTo("questionnaire")}>
          let's go
        </button>
      </div>
      <p
        className="tagline"
        style={{ fontSize: "0.9rem", marginTop: 32, opacity: 0.6 }}
      >
        ↑ click that whenever you're ready :)
      </p>
    </div>
  );
}
